import { Component, inject, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CustomersService, ICustomer } from '../../services/customers.service';
import { CreateCustomerModalComponent } from '../../components/create-customer-modal/create-customer-modal.component';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-fresh-page',
  imports: [CreateCustomerModalComponent, FormsModule],
  templateUrl: './customers.component.html',
  styleUrl: './customers.component.css'
})
export class CustomersComponent {
  private readonly customersService = inject(CustomersService);

  vouchersToAdd: number = 0;

  protected readonly customers = signal<ICustomer[]>([]);
  protected readonly totalRecords = signal<number>(0);
  protected readonly page = signal<number>(1);
  protected readonly pageSize = signal<number>(10);
  protected readonly totalPages = signal<number>(1);
  protected readonly isCreateOpen = signal<boolean>(false);
  protected readonly isAddingVouchers = signal<boolean>(false);

  constructor() {
    void this.loadCustomers();
  }

  protected async loadCustomers(): Promise<void> {
    const response = await firstValueFrom(
      this.customersService.listCustomers({
        page: this.page(),
        pageSize: this.pageSize()
      })
    );

    this.customers.set(response.customers);
    this.totalRecords.set(response.totalRecords);
    this.totalPages.set(Math.max(1, Math.ceil(response.totalRecords / response.pageSize)));
  }

  protected goToPage(page: number): void {
    const nextPage = Math.min(Math.max(1, page), this.totalPages());
    if (nextPage === this.page()) {
      return;
    }
    this.page.set(nextPage);
    void this.loadCustomers();
  }

  protected openCreateModal(): void {
    this.isCreateOpen.set(true);
  }

  protected closeCreateModal(): void {
    this.isCreateOpen.set(false);
  }

  protected async handleCustomerSaved(): Promise<void> {
    this.closeCreateModal();
    this.page.set(1);
    await this.loadCustomers();
  }

  addVouchers(customer: ICustomer, qty: any){
    if (Number(qty) <= 0) {
      return;
    }
    this.isAddingVouchers.set(true);
    this.customersService.addVouchers(customer, Number(qty)).subscribe(async () => {
      await this.loadCustomers();
      this.isAddingVouchers.set(false);
    });
  }
}
